import clsx from 'clsx';

import { useTableContext } from '@core/table/features/TableContext';
import type { Justify } from '@core/table/types';

import getTableBodyCellCss, { classes } from './styles/getTableBodyCellCss';

export type Props = {
  isHeader?: boolean;
  justify?: Justify;
} & React.ComponentProps<'td'>;

const TableCell = (props: Props) => {
  const { children, isHeader, justify, ...rest } = props;
  const { cellVerticalAlign } = useTableContext();

  return isHeader ? (
    <th
      className={clsx({
        [classes.endAligned]: justify === 'end',
        [classes.verticalMiddleAligned]: cellVerticalAlign === 'middle',
      })}
      css={getTableBodyCellCss}
      role="rowheader"
      scope="row"
      {...rest}
    >
      {children}
    </th>
  ) : (
    <td
      className={clsx({
        [classes.endAligned]: justify === 'end',
        [classes.verticalMiddleAligned]: cellVerticalAlign === 'middle',
      })}
      css={getTableBodyCellCss}
      data-testid="td"
      {...rest}
    >
      {children}
    </td>
  );
};

export default TableCell;
